// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/question-mark-circle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/question-mark-circle'

import { Icon, type IconComponentProps } from '../icon'

export const QuestionMarkCircleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
